define('SuiteCommerce.ItemBadges.GlobalViews', [
  'SuiteCommerce.ItemBadges.View'
], function ItemBadgesGlobalViews(
  ItemBadgesView
) {
  'use strict';
  return {
    loadGlobalViewsItemBadges: function loadGlobalViewsItemBadges(application, collection) {
      var layout = application.getComponent('Layout');
      this.addGlobalViewsChildViews(layout, collection);
    },
    addGlobalViewsChildViews: function addGlobalViewsChildViews(layout, collection) {
      layout.addChildView(
        'Item.Price',
        function childViewConstructor() {
          return new ItemBadgesView({
            view: 'global',
            collection: collection
          });
        }
      );
    }
  };
});
